import ApiService from '@/core/api/api.service';

import { functionsWithNotifications } from '@/core/notifications';
import workerOneTimePassMessages from './worker-one-time-pass.messages';
import WorkerOneTimePass from './worker-one-time-pass.mapper';

const functions = {
  create,
  get,
  getForWorker,
};

export default {
  ...functionsWithNotifications(functions, workerOneTimePassMessages),
  clearCache,
};

const workerOneTimePassApi = new ApiService();

async function create(workerUuid, oneTimePassUuid) {
  const requestBody = {
    worker_one_time_pass: {
      one_time_pass_uuid: oneTimePassUuid,
    },
  };

  const response = await workerOneTimePassApi.post(`workers/${workerUuid}/worker_one_time_passes`, requestBody);
  return new WorkerOneTimePass(response.data.data);
}

async function get(workerOneTimePassUuid) {
  const response = await workerOneTimePassApi.get(`worker_one_time_passes/${workerOneTimePassUuid}`);
  return new WorkerOneTimePass(response.data.data);
}

async function getForWorker(workerUuid, oneTimePassUuid) {
  const requestConfig = oneTimePassUuid ? {
    params: {
      one_time_pass_uuid: oneTimePassUuid,
    },
  } : {};
  const response = await workerOneTimePassApi.get(`workers/${workerUuid}/worker_one_time_passes`, requestConfig);
  return response.data.data.map(wotp => new WorkerOneTimePass(wotp));
}

async function clearCache() {
  workerOneTimePassApi.clearCache();
}
